var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "battle" } },
    [
      _c("div", { staticClass: "bg" }),
      _c("c-header-return", { attrs: { title: "盲盒之战" } }),
      !_vm.$screen.mobile
        ? _c("div", { staticClass: "user-tabs" }, [
            _c("ul", { staticClass: "user-tabs__list" }, [
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass: "user-tabs__btn",
                    class: { active: _vm.tabs == 0 },
                    on: {
                      click: function ($event) {
                        return _vm.switchTabs(0)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "battle.svg" },
                        }),
                        _c("div", [_vm._v("当前对战")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass: "user-tabs__btn user-tabs__btn--items",
                    class: { active: _vm.tabs == 1 },
                    on: {
                      click: function ($event) {
                        return _vm.switchTabs(1)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "battle.svg" },
                        }),
                        _c("div", [_vm._v("我的对战")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass: "user-tabs__btn user-tabs__btn--items",
                    class: { active: _vm.tabs == 2 },
                    on: {
                      click: function ($event) {
                        return _vm.switchTabs(2)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "battle.svg" },
                        }),
                        _c("div", [_vm._v("所有对战")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "user-tabs__btn user-tabs__btn--items active create",
                    on: { click: _vm.openCreateRoomModal },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "reg.svg" },
                        }),
                        _c("div", [_vm._v("创建对战")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm.battleChallengeDetail.isChallengeEnable
                ? _c("li", { staticClass: "user-tabs_challenge__item" }, [
                    !_vm.battleChallengeDetail.isCurrentlyInChallenge
                      ? _c("div", { staticClass: "user-tabs__challenge" }, [
                          _c(
                            "div",
                            { staticClass: "user-tabs__challenge__top" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/help_fill.png"),
                                },
                                on: {
                                  click: function () {
                                    _vm.battle_challenge_des_show = true
                                    _vm.battle_challenge_des_btn_show = false
                                  },
                                },
                              }),
                              _c("p", [_vm._v("连胜挑战")]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "user-tabs__challenge__bottom" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "join-challenge-btn",
                                  on: { click: _vm.onJoinChallengeHandle },
                                },
                                [_vm._v("加入")]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.battleChallengeDetail.isCurrentlyInChallenge
                      ? _c(
                          "div",
                          { staticClass: "flex flex-ver" },
                          [
                            _c(
                              "div",
                              { staticClass: "user-tabs__challenge-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "user-tabs__challenge__left" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-tabs__challenge__left_top flex flex-ver",
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "tishi-item",
                                          attrs: {
                                            src: require("../../assets/images/help_fill.png"),
                                          },
                                          on: {
                                            click: function () {
                                              _vm.battle_challenge_des_show = true
                                              _vm.battle_challenge_des_btn_show = false
                                            },
                                          },
                                        }),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "user-tabs__challenge__winningSteakCount",
                                          },
                                          [
                                            _vm._v(
                                              " 连胜" +
                                                _vm._s(
                                                  _vm.battleChallengeDetail
                                                    .winningSteakCount || "-"
                                                ) +
                                                "关"
                                            ),
                                          ]
                                        ),
                                        _vm.battleChallengeDetail
                                          .winningSteakCount < 3
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "no-receivedGift-btn",
                                              },
                                              [_vm._v("无奖励")]
                                            )
                                          : _c(
                                              "button",
                                              {
                                                staticClass: "receivedGift-btn",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.battle_challenge_receivedGift_show = true
                                                  },
                                                },
                                              },
                                              [_vm._v("领取奖励")]
                                            ),
                                      ]
                                    ),
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-tabs__challenge__left_text text_yellow_item",
                                        },
                                        [
                                          _vm.battleChallengeDetail
                                            .winningSteakCount > 2
                                            ? _c("p", [
                                                _vm._v(
                                                  " 可领取奖励  " +
                                                    _vm._s(
                                                      _vm.battleChallengeDetail.firstTickePrice.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    " X " +
                                                    _vm._s(
                                                      _vm.curCDKRateObj.rate
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _c("p", [
                                                _vm._v(
                                                  " 差" +
                                                    _vm._s(
                                                      _vm.curCDKRateObj.num -
                                                        _vm
                                                          .battleChallengeDetail
                                                          .winningSteakCount
                                                    ) +
                                                    "关可领取  " +
                                                    _vm._s(
                                                      _vm.battleChallengeDetail.firstTickePrice.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    " X " +
                                                    _vm._s(
                                                      _vm.curCDKRateObj.rate
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-tabs__challenge__left_text pc__qianyiguan__item",
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "前一关总价格  " +
                                                _vm._s(
                                                  _vm.battleChallengeDetail.lastTicketPrice.toFixed(
                                                    2
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c("c-countDown", {
                              staticClass: "user-tabs__countDown__item",
                              on: { countdownDinished: _vm.onCoundownDinished },
                              model: {
                                value: _vm.countDownVauless,
                                callback: function ($$v) {
                                  _vm.countDownVauless = $$v
                                },
                                expression: "countDownVauless",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _c(
              "button",
              {
                staticClass: "btn-create",
                on: { click: _vm.openCreateRoomModal },
              },
              [_vm._v("创建对战")]
            ),
          ])
        : _vm._e(),
      _vm.$screen.mobile
        ? _c(
            "div",
            {
              staticClass:
                "homeContainerItem-content-queryItem-all flex flex-center-1",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "homeContainerItem-content-queryItem flex flex-ver",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "category-items flex flex-ver",
                      class: { active: _vm.tabs == 0 },
                      on: {
                        click: function ($event) {
                          return _vm.switchTabs(0)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "category-items-icon el-icon-menu",
                      }),
                      _c("p", [_vm._v("当前对战")]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "category-items flex flex-ver",
                      class: { active: _vm.tabs == 1 },
                      on: {
                        click: function ($event) {
                          return _vm.switchTabs(1)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "category-items-icon el-icon-menu",
                      }),
                      _c("p", [_vm._v("我的对战")]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "category-items flex flex-ver",
                      class: { active: _vm.tabs == 2 },
                      on: {
                        click: function ($event) {
                          return _vm.switchTabs(2)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "category-items-icon el-icon-menu",
                      }),
                      _c("p", [_vm._v("所有对战")]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "icon flex flex-center-1",
                  class: { "icon-active": _vm.isShowShaixuan },
                  on: { click: _vm.openCreateRoomModal },
                },
                [_vm._v(" 创建对战 ")]
              ),
              _c("div", { staticClass: "shadow" }),
            ]
          )
        : _vm._e(),
      _vm.battleChallengeDetail.isChallengeEnable && _vm.$screen.mobile
        ? _c("div", { staticClass: "new_phone_tabs__challenge" }, [
            !_vm.battleChallengeDetail.isCurrentlyInChallenge
              ? _c("div", { staticClass: "tabs__challenge" }, [
                  _c("img", {
                    staticClass: "tabs__challenge_bg",
                    attrs: {
                      src: require("../../assets/images/battleBg.png"),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "tabs__challenge_item" }, [
                    _c("img", {
                      staticClass: "tabs__challenge_item_left",
                      attrs: {
                        src: require("../../assets/images/help_fill.png"),
                      },
                      on: {
                        click: function () {
                          _vm.battle_challenge_des_show = true
                          _vm.battle_challenge_des_btn_show = false
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "tabs__challenge_item_right flex flex-ver",
                      },
                      [
                        _c("img", {
                          staticClass: "battleBg_icon",
                          attrs: {
                            src: require("../../assets/images/battleBg_icon.png"),
                            alt: "",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "btn flex flex-center-1",
                            on: { click: _vm.onJoinChallengeHandle },
                          },
                          [_vm._v("加入")]
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.battleChallengeDetail.isCurrentlyInChallenge
              ? _c("div", { staticClass: "tabs__challenge_1" }, [
                  _c("img", {
                    staticClass: "tabs__challenge_bg",
                    attrs: {
                      src: require("../../assets/images/battleingBg.png"),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "tabs__challenge_item_1" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "tabs__challenge_item_left_1 flex flex-col flex-jcsb",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "tabs__challenge_item_left_top flex flex-ver",
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "challenge__winningSteakCount" },
                              [
                                _vm._v(
                                  " 连胜" +
                                    _vm._s(
                                      _vm.battleChallengeDetail
                                        .winningSteakCount || "-"
                                    ) +
                                    "关"
                                ),
                              ]
                            ),
                            _c("img", {
                              staticClass: "tishi-item",
                              attrs: {
                                src: require("../../assets/images/help_fill.png"),
                              },
                              on: {
                                click: function () {
                                  _vm.battle_challenge_des_show = true
                                  _vm.battle_challenge_des_btn_show = false
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "tabs__challenge_item_left_bottom flex flex-ver",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "challenge_item_left_bottom_text",
                              },
                              [
                                _vm.battleChallengeDetail.winningSteakCount > 2
                                  ? _c("p", [
                                      _vm._v(
                                        " 可领取奖励  " +
                                          _vm._s(
                                            _vm.battleChallengeDetail.firstTickePrice.toFixed(
                                              2
                                            )
                                          ) +
                                          " X " +
                                          _vm._s(_vm.curCDKRateObj.rate) +
                                          " "
                                      ),
                                    ])
                                  : _c("p", [
                                      _vm._v(
                                        " 差" +
                                          _vm._s(
                                            _vm.curCDKRateObj.num -
                                              _vm.battleChallengeDetail
                                                .winningSteakCount
                                          ) +
                                          "关可领取  " +
                                          _vm._s(
                                            _vm.battleChallengeDetail.firstTickePrice.toFixed(
                                              2
                                            )
                                          ) +
                                          " X " +
                                          _vm._s(_vm.curCDKRateObj.rate) +
                                          " "
                                      ),
                                    ]),
                              ]
                            ),
                            _c("div", { staticClass: "qianyiguan__item" }, [
                              _c("p", [
                                _vm._v(
                                  "前一关总价格  " +
                                    _vm._s(
                                      _vm.battleChallengeDetail.lastTicketPrice.toFixed(
                                        2
                                      )
                                    )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "tabs__challenge_item_right_1 flex flex-col flex-ver",
                      },
                      [
                        _c("c-countDown", {
                          staticClass: "countDown_item_1",
                          on: { countdownDinished: _vm.onCoundownDinished },
                          model: {
                            value: _vm.countDownVauless,
                            callback: function ($$v) {
                              _vm.countDownVauless = $$v
                            },
                            expression: "countDownVauless",
                          },
                        }),
                        _vm.battleChallengeDetail.winningSteakCount < 3
                          ? _c(
                              "button",
                              { staticClass: "btn no-receivedGift-btn" },
                              [_vm._v("无奖励")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn receivedGift-btn",
                                on: {
                                  click: function ($event) {
                                    _vm.battle_challenge_receivedGift_show = true
                                  },
                                },
                              },
                              [_vm._v("领取奖励")]
                            ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      !_vm.$screen.mobile
        ? [
            _vm._m(0),
            _c(
              "transition-group",
              {
                staticClass: "battle-table",
                attrs: { name: "battleroom", tag: "div" },
              },
              _vm._l(_vm.roomList, function (room) {
                return _c("c-room-item", {
                  key: _vm.tabs + "-" + room.id,
                  attrs: { item: room, server_time: _vm.server_time },
                  on: {
                    handleJoinPk: _vm.openJoinRoomModal,
                    on_room_end: function ($event) {
                      return _vm.onRoomEnd(room)
                    },
                  },
                })
              }),
              1
            ),
          ]
        : _vm._e(),
      _vm.$screen.mobile
        ? [
            _c("div", { staticClass: "new-mobile-table" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "new-mobile-tableContent" },
                _vm._l(_vm.roomList, function (items, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "new-mobile-tableContent-item flex flex-ais flex-jcsb",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "tableContent-item-item width-1" },
                        [
                          _c(
                            "div",
                            { staticClass: "circle flex flex-center-1" },
                            [
                              _c("div", { staticClass: "flex flex-center-1" }, [
                                _vm._v(_vm._s(items.cases.length)),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "juhao-text" }, [
                            _vm._v(_vm._s(items.id)),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "tableContent-item-item width-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "baoxiang-item" },
                            [
                              items.cases
                                ? [
                                    _vm._l(
                                      items.cases,
                                      function (caseItem, indexs) {
                                        return [
                                          indexs < 5
                                            ? _c(
                                                "div",
                                                {
                                                  key: indexs,
                                                  staticClass:
                                                    "baoxiang-text flex flex-col flex-center-1",
                                                },
                                                [
                                                  caseItem.casePic
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: _vm.$imgfilter(
                                                            caseItem.casePic
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(caseItem.caseName)
                                                    ),
                                                  ]),
                                                  indexs == 5 &&
                                                  items.cases.length > 6
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "caseshengyunum flex flex-center-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "+" +
                                                              _vm._s(
                                                                parseInt(
                                                                  items.cases
                                                                    .length - 6
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "tableContent-item-item width-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "last-item flex flex-col flex-ver" },
                            [
                              _c(
                                "div",
                                { staticClass: "user-list" },
                                [
                                  _vm._l(items.players, function (user) {
                                    return _c(
                                      "div",
                                      {
                                        key: user.id,
                                        staticClass: "img",
                                        class: {
                                          isWin:
                                            user.isWinner &&
                                            items.roomState == 2,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "mark-win" }),
                                        _c("c-avatar", {
                                          attrs: {
                                            src: user.avatar
                                              ? _vm.$imgfilter(user.avatar)
                                              : require("@/assets/images/user/ava_none.jpg"),
                                            vip: user.vipLevel,
                                            is_streamer: user.isStreamer,
                                            is_robot: user.isRobot,
                                            curr_metal_url: user.currMetalUrl,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._l(
                                    items.seatCount - items.players.length,
                                    function (n) {
                                      return _c("div", {
                                        key: n,
                                        staticClass: "img join",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleMobileJoinPk(
                                              items,
                                              ""
                                            )
                                          },
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "jiage-item flex flex-col flex-ver",
                                },
                                [
                                  _c("div", { staticClass: "jiage-text" }, [
                                    _vm._v(_vm._s(items.roomPrice)),
                                    _vm.isHappyCoin
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                            },
                                          },
                                          [_vm._v("欢乐豆")]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "btns-item flex flex-center-1",
                                  class: {
                                    otherStyle: items.roomState != 0,
                                    lock: items.password != "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleShowRoomDetail(items)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        items.roomState == 0
                                          ? "进入"
                                          : "查看战斗"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.curUserRealId == items.memberid &&
                              items.roomState == 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btns-item flex flex-center-1",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleMobileJoinPk(
                                            items,
                                            "ai"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 匹配AI ")]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "updatedTime-items" }, [
                                _vm._v(_vm._s(items.updatedTime)),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        : _vm._e(),
      _vm.tabs == 2
        ? _c(
            "div",
            [
              _c("Page", {
                attrs: {
                  current: _vm.pageIndex,
                  total: _vm.total,
                  "page-size": _vm.pageSize,
                },
                on: {
                  "update:current": function ($event) {
                    _vm.pageIndex = $event
                  },
                  "on-change": _vm.onPageChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "'400rem'",
            closable: false,
          },
          model: {
            value: _vm.join_room_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.join_room_modal, "flag", $$v)
            },
            expression: "join_room_modal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "加入对战", has_close_button: "" },
              on: {
                close_button_click: function () {
                  return (_vm.join_room_modal.flag = false)
                },
              },
            },
            [
              _c("div", { staticClass: "app-form" }, [
                _c("p", { staticClass: "join_room_modal_desc" }, [
                  _vm._v(" 加入房间需要花费 "),
                  _c("span", { staticClass: "price-text" }, [
                    _vm._v(_vm._s(_vm.join_room_modal.price) + " "),
                    _vm.isHappyCoin
                      ? _c("span", { staticStyle: { "font-size": "12px" } }, [
                          _vm._v("欢乐豆"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm.join_room_modal.hasPassword
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.join_room_modal.password,
                        expression: "join_room_modal.password",
                      },
                    ],
                    staticClass: "form-input",
                    attrs: { placeholder: "请输入房间密码" },
                    domProps: { value: _vm.join_room_modal.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.join_room_modal,
                          "password",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.submit_join_room },
                },
                [_vm._v(" 确认加入 ")]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "800rem",
            "full-screen": this.$screen.mobile,
            closable: false,
          },
          model: {
            value: _vm.create_room_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.create_room_modal, "flag", $$v)
            },
            expression: "create_room_modal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "创建房间", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.create_room_modal.flag = false
                },
              },
            },
            [
              _vm.create_room_modal.flag
                ? _c("c-new-room", {
                    ref: "cNewRoom",
                    attrs: { pkBoxList: _vm.battleCaseList },
                    on: { createRoom: _vm.createRoom },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Drawer",
        {
          attrs: {
            "class-name": "app-drawer",
            placement: "bottom",
            height: "350",
          },
          model: {
            value: _vm.case_detail_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.case_detail_modal, "flag", $$v)
            },
            expression: "case_detail_modal.flag",
          },
        },
        [
          _c("c-battleCaseDetail", {
            attrs: { caseInfo: _vm.case_detail_modal.caseInfo },
          }),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "battle-newroom-modal",
            "footer-hide": "",
            width: "100vw",
          },
          model: {
            value: _vm.mobile_ranking_flag,
            callback: function ($$v) {
              _vm.mobile_ranking_flag = $$v
            },
            expression: "mobile_ranking_flag",
          },
        },
        [
          _c("div", { staticClass: "battle_ranking" }, [
            _c("div", { staticClass: "ranking-header-container" }, [
              _vm.GameHistory.yesterday_star.name
                ? _c("div", { staticClass: "ranking-header" }, [
                    _c("div", { staticClass: "avatar-box" }, [
                      _c("img", {
                        staticClass: "user-avatar",
                        attrs: {
                          src: _vm.GameHistory.yesterday_star.avatar
                            ? _vm.$imgfilter(
                                _vm.GameHistory.yesterday_star.avatar
                              )
                            : require("@/assets/images/user/ava_none.jpg"),
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "top-user" }, [
                      _c("div", { staticClass: "user-nick text-ellipsis" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.GameHistory.yesterday_star.name) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "user-m" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.GameHistory.yesterday_star.profit.toFixed(2)
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "rank_tabs" }, [
              _c(
                "div",
                {
                  class: { active: _vm.GameHistory.curTab == 0 },
                  on: {
                    click: function ($event) {
                      _vm.GameHistory.curTab = 0
                    },
                  },
                },
                [_vm._v(" 今日 ")]
              ),
              _c(
                "div",
                {
                  class: { active: _vm.GameHistory.curTab == 1 },
                  on: {
                    click: function ($event) {
                      _vm.GameHistory.curTab = 1
                    },
                  },
                },
                [_vm._v(" 昨日 ")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "user-list" },
              [
                _vm._l(_vm.GameHistory.yesterday_list, function (item, index) {
                  return _vm.GameHistory.curTab == 1
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "item-inner" }, [
                          _c("img", {
                            staticClass: "avatar",
                            attrs: {
                              src: item.avatar
                                ? _vm.$imgfilter(item.avatar)
                                : require("@/assets/images/user/ava_none.jpg"),
                            },
                          }),
                          _c("span", { staticClass: "nick text-ellipsis" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "money text-ellipsis",
                              attrs: { title: item.profit.toFixed(2) },
                            },
                            [_c("i", [_vm._v(_vm._s(item.profit.toFixed(2)))])]
                          ),
                        ]),
                      ])
                    : _vm._e()
                }),
                _vm._l(_vm.GameHistory.today_list, function (item, index) {
                  return _vm.GameHistory.curTab == 0
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "item-inner" }, [
                          _c("img", {
                            staticClass: "avatar",
                            attrs: {
                              src: item.avatar
                                ? _vm.$imgfilter(item.avatar)
                                : require("@/assets/images/user/ava_none.jpg"),
                            },
                          }),
                          _c("span", { staticClass: "nick text-ellipsis" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "money text-ellipsis",
                              attrs: { title: item.profit.toFixed(2) },
                            },
                            [_c("i", [_vm._v(_vm._s(item.profit.toFixed(2)))])]
                          ),
                        ]),
                      ])
                    : _vm._e()
                }),
              ],
              2
            ),
          ]),
        ]
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "盲盒对战活动说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(
                    " 1、创建活动时，可以选择活动人数【双人模式】【三人模式】进行对战，一场战斗最多可以选择6个饰品箱。※房间一旦创建，不可取消。 "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " 2、活动参与費用即本场活动开启的饰品箱价格总和，支付费用后即视为加入房间。※中途退出房间，并不会退还饰品箱或参与费。 "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " 3、当一场活动有多名赢家均分奖励时，非本人所得饰品将被兑换为硬币发放到赢家帐户馀额。 "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " 4、每场活动的结果受到【创建时间】【用户ID】【用户位置】【开始时间】等，多方面因素影响，此为完全随机产生的结果。任意饰品箱奖励均可以验证公平性。 "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "500rem",
            closable: false,
          },
          model: {
            value: _vm.battle_challenge_des_show,
            callback: function ($$v) {
              _vm.battle_challenge_des_show = $$v
            },
            expression: "battle_challenge_des_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "连胜挑战活动说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.battle_challenge_des_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content challenge_des_item" }, [
                _c(
                  "p",
                  [
                    _vm._v(" 获胜任一关盒战即可参加连胜挑战活动:"),
                    _c("br"),
                    _vm._l(_vm.cdkGiftRateList, function (item) {
                      return [
                        _vm._v(
                          " 连胜" +
                            _vm._s(item.num) +
                            "关，奖励为第1关的门票总价格 X " +
                            _vm._s(item.rate) +
                            "倍数 CDK。"
                        ),
                        _c("br"),
                      ]
                    }),
                    _vm._v(" (第一位连胜12关的玩家，送 "),
                    _c("strong", [_vm._v("AWP王子-崭新出厂")]),
                    _vm._v("一把) "),
                    _c("br"),
                    _c("br"),
                    _vm._v(" 注意事项: "),
                    _c("br"),
                    _vm._v(
                      " 1. 下一关门票总价格必须高于前一关，胜利才符合连胜资格。"
                    ),
                    _c("br"),
                    _vm._v(" 2. 对战失败时挑战结束，无法领取连胜奖励。"),
                    _c("br"),
                    _vm._v(" 3. 领取当前连胜奖励后，挑战结束。"),
                    _c("br"),
                    _vm._v(" 4. 未领取连胜奖励，默认为继续挑战。 "),
                    _c("br"),
                    _vm._v(
                      " 5. 当挑战计时倒数至0，挑战结束，无法领取连胜奖励。"
                    ),
                    _c("br"),
                    _vm._v(
                      " 6. 门票总价格低于或等于前一关，胜利不加连胜，失败挑战结束。"
                    ),
                    _c("br"),
                    _vm._v(" 7. 若对战平局，保留连胜次数，可继续挑战。 "),
                    _c("br"),
                    _vm._v("8. 连胜挑战活动可重复游玩，不限次数。 "),
                    _c("br"),
                    _vm._v(" 9. 连胜挑战活动如遇BUG，解释权，属于口令专员。"),
                    _c("br"),
                  ],
                  2
                ),
                _vm.battle_challenge_des_btn_show
                  ? _c(
                      "div",
                      { staticClass: "challenge_des_btn flex flex-center-1" },
                      [
                        _vm.battleChallengeDetail.winningSteakCount > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "agree-btn",
                                on: { click: _vm.onGCRequestJoinChallenge },
                              },
                              [_vm._v("同意")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "noOk-btn",
                                on: {
                                  click: function ($event) {
                                    _vm.battle_challenge_des_show = false
                                  },
                                },
                              },
                              [_vm._v("资格不符")]
                            ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "500rem",
            closable: false,
          },
          model: {
            value: _vm.battle_challenge_receivedGift_show,
            callback: function ($$v) {
              _vm.battle_challenge_receivedGift_show = $$v
            },
            expression: "battle_challenge_receivedGift_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "确认结束连胜挑战活动？", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.battle_challenge_receivedGift_show = false
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "text-content challenge_receivedGift_item flex flex-col flex-center-1",
                },
                [
                  _c("p", { staticClass: "receivedGift_text_item" }, [
                    _vm._v(
                      " 连胜" +
                        _vm._s(_vm.battleChallengeDetail.winningSteakCount) +
                        "关可获得 "
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "receivedGift_golden_item flex flex-ver" },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.battleChallengeDetail.giftAmount.toFixed(2)
                          )
                        ),
                      ]),
                      _c("c-svg", {
                        attrs: {
                          src: "bill.svg",
                          width: "25",
                          height: "25",
                          fill: "#4762f2",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "receivedGift_btns_item flex flex-center-1",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "receivedGift_ok_btn",
                          on: { click: _vm.onGCReceiveReward },
                        },
                        [_vm._v("确认")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "receivedGift_cancel_btn",
                          on: {
                            click: function ($event) {
                              _vm.battle_challenge_receivedGift_show = false
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "battle__header" }, [
      _c("div", { staticClass: "battle__header-item battle__header--round" }, [
        _vm._v("回合"),
      ]),
      _c("div", { staticClass: "battle__header-item battle__header--id" }, [
        _vm._v("局号"),
      ]),
      _c("div", { staticClass: "battle__header-item battle__header--box" }, [
        _vm._v("对战场景"),
      ]),
      _c("div", { staticClass: "battle__header-item battle__header--price" }, [
        _vm._v("价格"),
      ]),
      _c(
        "div",
        { staticClass: "battle__header-item battle__header--players" },
        [_vm._v("玩家")]
      ),
      _c("div", { staticClass: "battle__header-item battle__header--round" }),
      _c("div", { staticClass: "battle__header-item battle__header--time" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "new-mobile-tableHeader flex flex-ais flex-jcsb" },
      [
        _c(
          "div",
          { staticClass: "tableHeader-item flex flex-center-1 width-1" },
          [_vm._v("回合")]
        ),
        _c(
          "div",
          { staticClass: "tableHeader-item flex flex-center-1 width-2" },
          [_vm._v("对战场景")]
        ),
        _c(
          "div",
          { staticClass: "tableHeader-item flex flex-center-1 width-4" },
          [_vm._v("价格")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }